export const messages = {
  en: {
    propertyCommunity: {
      search: {
        title: 'Search Conditions',
        communityId: 'Please enter community ID',
        name: 'Please enter community name'
      },
      list: {
        title: 'Community Information',
        add: 'Join Community',
        quit: 'Quit Community'
      },
      table: {
        communityId: 'Community ID',
        name: 'Community Name',
        nearbyLandmarks: 'Nearby Landmarks',
        cityCode: 'City Code',
        state: 'Status'
      },
      add: {
        title: 'Add Community',
        openCommunity: 'Open Community',
        selectCommunity: 'Optional, please select community',
        functions: 'Functions',
        all: 'All'
      },
      edit: {
        title: 'Edit Community',
        openCommunity: 'Open Community',
        functions: 'Functions',
        all: 'All'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to quit this community?',
        cancel: 'Cancel',
        confirmButton: 'Confirm Quit'
      },
      fetchError: 'Failed to fetch community data'
    },

  },
  zh: {
    propertyCommunity: {
      search: {
        title: '查询条件',
        communityId: '请输入小区编号',
        name: '请输入小区名称'
      },
      list: {
        title: '小区信息',
        add: '加入小区',
        quit: '退出小区'
      },
      table: {
        communityId: '小区ID',
        name: '小区名称',
        nearbyLandmarks: '附近地标',
        cityCode: '城市编码',
        state: '状态'
      },
      add: {
        title: '添加小区',
        openCommunity: '开通小区',
        selectCommunity: '选填，请选择开通小区',
        functions: '功能',
        all: '全部'
      },
      edit: {
        title: '修改小区',
        openCommunity: '开通小区',
        functions: '功能',
        all: '全部'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定退出小区吗？',
        cancel: '点错了',
        confirmButton: '确认退出'
      },
      fetchError: '获取小区数据失败'
    },
  }
}